/* eslint-disable react/forbid-elements */
import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetch } from '../../../store/openApiFetch';
import { useOpenApiFetch } from '../../../store/useOpenApiFetch';
import { CollapsiblePanel, EditPanel, EditPanelButton, EditPanelCell, EditPanelRow, EditPanelTextArea, PanelBody } from '../../elements';
import { Comment } from './Comment';

export function SurveyEditWorkflowCommentsBody(props: { surveyId: string }) {
    const { surveyId } = props;
    const translate = useTranslate();
    const [text, setText] = React.useState('');
    const { data, reload } = useOpenApiFetch('/api/surveys/{surveyId}/workflow/comments', 'get', { surveyId }, []);

    async function createComment() {
        await openApiFetch('/api/surveys/{surveyId}/workflow/comments', 'post', { surveyId }, { text });
        setText('');
        await reload();
    }

    return (
        <PanelBody isForm={true}>
            <EditPanelRow>
                <EditPanelCell rowCount={9}>
                    <EditPanelTextArea
                        value={text}
                        handleChange={(value) => setText(value)}
                        name="text"
                        icon="fa fa-comments"
                        placeholder={translate('workflow.comment')}
                    />
                </EditPanelCell>
                <EditPanelCell rowCount={3}>
                    <EditPanelButton primary text={translate('workflow.addComment')} onClick={createComment} iconClass="fa fa-save" small />
                </EditPanelCell>
            </EditPanelRow>
            {data && data.length > 0 && (
                <div className="bg-light darker pn">
                    {data.map((comment) => (
                        <Comment
                            key={comment.id}
                            id={comment.id}
                            commentedBy={comment.commentedBy}
                            commentedOn={comment.commentedOn}
                            text={comment.text}
                        />
                    ))}
                </div>
            )}
        </PanelBody>
    );
}

export function SurveyEditWorkflowComments(props: { surveyId: string }) {
    const { surveyId } = props;
    const translate = useTranslate();

    return (
        <EditPanel bottomMargin={true} noPadding={true}>
            <CollapsiblePanel heading={{ dark: true, text: translate('workflow.comments'), initialIsClosed: true }}>
                <SurveyEditWorkflowCommentsBody surveyId={surveyId} />
            </CollapsiblePanel>
        </EditPanel>
    );
}
